<template>
  <div class="pc-image-edit">
    <slot name="header" />
    <div class="pc-image-show">
      <div class="add-images">
        <div class="images">
          <div class="image" v-for="(item, index) in dataDetail" :key="index">
            <div class="mask" v-if="editCity">
              <p @click="deleteImage(index)">X</p>
            </div>
            <video
              v-if="item.video"
              :src="item.video"
              controls="controls"
              poster="封面"
            ></video>
            <div class="title">
              <span>名称：</span>
              <span v-if="!editCity">{{ item.title }}</span>
              <el-input
                v-if="editCity"
                v-model="item.title"
                placeholder="视频名称"
              ></el-input>
            </div>
            <div>
              <span>来源：</span>
              <span v-if="!editCity">{{ item.intro }}</span>
              <el-input
                v-if="editCity"
                v-model="item.intro"
                placeholder="视频来源"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="new-image">
          <el-upload
            v-if="editCity && percentage == 0"
            class="logoImg"
            action="#"
            list-type="picture-card"
            accept=".avi,.rmvb,.rm ,.asf ,.divx ,.mpg ,.mpeg ,.mpe ,.wmv ,.mp4 ,.mkv ,.vob"
            :http-request="uploadVideo"
            :show-file-list="false"
            :auto-upload="true"
          >
            <p class="img-hint">添加城市视频</p>
          </el-upload>

          <div class="process" v-if="percentage != 0">
            <el-progress
              type="circle"
              :width="100"
              :percentage="this.percentage"
            ></el-progress>
          </div>
        </div>
      </div>
    </div>

    <!-- {{ dataDetail.images }} -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      percentage: 0,
    };
  },
  props: { dataDetail: Array, editCity: Boolean },
  methods: {
    async uploadVideo(params) {
      console.dir(params.file.name);
      let config = {
        onUploadProgress: (progressEvent) => {
          process =
            (progressEvent.loaded / progressEvent.total).toFixed(2) * 100;
          this.percentage = parseInt(process);
        },
      };
      this.$global.uploadVideoWithConfig(this, params, config).then((res) => {
        // this.$set(this.cityDetail, "formImage", res.split("?")[0]);
        this.percentage = 0;
        this.$emit("updateImage", res.url.split("?")[0], params.file.name);
      });
    },
    deleteImage(index) {
      this.$emit("deleteImage", index);
    },
  },
};
</script>

<style scoped lang='scss'>
.pc-image-edit {
  box-shadow: $boxshadow;
  padding: 35px 30px 20px;
  margin-top: 40px;
  > h2 {
    border-bottom: 1px solid $border-color;
    font-size: 20px;
    padding-bottom: 15px;
    color: $mainTitle;
  }
  .pc-image-show {
    overflow: auto;
    .add-images {
      display: flex;
      padding-bottom: 20px;
      .images {
        display: flex;
        .image {
          padding-top: 20px;
          width: 260px;
          cursor: pointer;
          position: relative;
          margin-right: 20px;
          /deep/ .el-input {
            margin-top: 5px;
            width: 190px;
          }
          .title {
            word-break: break-all;
            margin-top:5px;
            margin-bottom: 10px;
          }
          video {
            object-fit: cover;
            width: 250px;
            height: 120px;
          }
          p {
            width: 250px;
            margin-top: 10px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .mask {
            position: absolute;
            background: transparent;
            z-index: 100;
            width: 250px;
            height: 20px;

            p {
              position: absolute;
              background: $base-color;
              cursor: pointer;
              z-index: 100;
              color: $secondTitle;
              top: -8px;
              right: -8px;
              box-shadow: $boxshadow;
              // margin-left:220px;
              margin-top: 0px;
              text-align: center;
              height: 20px;
              line-height: 20px;
              font-weight: bold;
              width: 20px;
              border-radius: 50%;
              border: 1px solid $base-color;
            }
            p:hover {
              color: $lightenYellow;
            }
          }
        }
        .image:hover {
          video,
          .mask {
            transition: all 0.2s;
            transform: translateY(-10px);
          }
        }
      }
      .new-image {
        padding-top: 20px;
        .img-hint {
          height: 120px;
          line-height: 120px;
          color: #5470c6;
          font-size: 20px;
        }
        .process {
          width: 248px;
          height: 120px;
          text-align: center;
          border-radius: 6px;
          border: 1px dashed $timeBtn;
          padding-top: 10px;
          background: #fbfdff;
        }
        /deep/ .el-input {
          margin-top: 20px;
          width: 210px;
        }
        /deep/ .el-upload--picture-card {
          width: 250px;
          height: 120px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/map/cityDetail/videoEdit.vue